import { ThemeInterface } from "@styles/theme";

export const commonStyles = (theme: ThemeInterface) => ({
	inputWidthPrimary: {
		width: "328px",
	},
	profileIcon: {
		color: theme.palette.secondary.light,
	},
	mvTitle: {
		fontSize: "20px",
		letterSpacing: "0.25px",
	},
	pageWrapper: {
		width: "100%",
		height: "768px",
		backgroundColor: theme.palette.blueGrey.light,
	},

	formBox: {
		width: "288px",
		height: "40px",
		borderRadius: "4px",
	},
	verticleAlign: {
		display: "flex",
		alignItems: "center",
	},
	grow: {
		flexGrow: 1,
	},
	sectionDesktop: {
		display: "none",
		[theme.breakpoints.up("md")]: {
			display: "flex",
		},
	},
	brandLogo: {
		width: "124px",
		marginLeft: "32px",
		cursor: "pointer",
	},
	webLogo: {
		"& div": {
			// height: "32px"
		},
		minHeight: "56px",
		paddingLeft: "0px",
	},
	iconButton: {
		marginRight: "8px",
	},
	accountIcon: {
		color: theme.palette.secondary.light,
	},
	colorDarkGrey: {
		color: theme.palette.grey[900],
	},
	colorMain: {
		color: theme.palette.primary.main,
	},
	itemWidth: {
		width: "100%",
	},

	/**
	 *  common style classes
	 */
	bold: {
		fontWeight: "600",
	},
	fontWeight400: {
		fontWeight: "400 !important",
	},
	fontWeight600: {
		fontWeight: "600",
	},
	bold2: {
		fontWeight: "800",
	},
	gridContainer: {
		margin: "unset !important",
		width: "100%",
		// overflow:'auto'
	},
	widthMargin: {
		margin: "unset !important",
	},
	widthFit: {
		width: "100%",
	},
	heightFit: {
		height: "100% !important",
	},
	blackColor: {
		color: theme.palette.grey[900],
	},
	whiteColor: {
		color: `${theme.palette.common.white} !important`,
	},
	textUpperCase: {
		textTransform: "uppercase",
	},
	txtAlignCenter: {
		textAlign: "center",
	},
	textAlignLeft: {
		textAlign: "left",
	},
	textAlignRight: {
		textAlign: "right",
	},
	textCut: {
		textDecoration: "line-through",
	},
	tSuccess: {
		color: `${theme.palette.success.main} !important`,
	},

	/** padding classes */
	padding32: {
		padding: "32px",
	},
	padding16: {
		padding: "16px",
	},
	padding4: {
		padding: "4px !important",
	},
	padding0: {
		padding: "0 !important",
	},
	padding8: {
		padding: "8px !important",
	},
	paddingBottom0: {
		paddingBottom: "0 !important",
	},
	paddingBottom8: {
		paddingBottom: "8px !important",
	},
	paddingBottom12: {
		paddingBottom: "12px !important",
	},
	paddingBottom16: {
		paddingBottom: "1rem !important",
	},

	paddingTop0: {
		paddingTop: "0 !important",
	},
	paddingTop8: {
		paddingTop: "8px !important",
	},
	paddingTop16: {
		paddingTop: "16px !important",
	},
	paddingTop24: {
		paddingTop: "24px !important",
	},
	paddingTop32: {
		paddingTop: "32px !important",
	},
	paddingLeft0: {
		paddingLeft: "0px !important",
	},
	paddingLeft4: {
		paddingLeft: "4px",
	},
	paddingLeft8: {
		paddingLeft: "8px",
	},
	paddingLeft16: {
		paddingLeft: "16px",
	},
	paddingLeft32: {
		paddingLeft: "32px",
	},
	paddingRight8: {
		paddingRight: "8px",
	},
	paddingRight16: {
		paddingRight: "1rem !important",
	},
	paddingRight0: {
		paddingRight: "0px !important",
	},
	paddingTopBottom12: {
		paddingTop: "12px",
		paddingBottom: "12px",
	},
	paddingLeftRight16: {
		paddingLeft: "16px",
		paddingRight: "16px",
	},

	/** margin classes */
	margin0: {
		margin: "0 !important",
	},
	marginTop4: {
		marginTop: "4px !important",
	},
	marginTop8: {
		marginTop: "0.5rem !important",
	},
	marginRight12: {
		marginRight: "12px",
	},
	marginTop16: {
		marginTop: "1rem !important",
	},
	marginTop24: {
		marginTop: "1.5rem !important",
	},
	marginBottom16: {
		marginBottom: "16px !important",
	},
	marginBottom8: {
		marginBottom: "8px !important",
	},
	marginBottom24: {
		marginBottom: "1.5rem !important",
	},
	marginTop32: {
		marginTop: "2rem !important",
	},
	marginLeft8: {
		marginLeft: "8px !important",
	},
	marginLeft16: {
		marginLeft: "16px !important",
	},
	marginRight8: {
		marginRight: "8px !important",
	},
	marginRight4: {
		marginRight: "4px !important",
	},
	marginRight16: {
		marginRight: "16px !important",
	},
	marginRight32: {
		marginRight: "32px !important",
	},
	marginLeft4: {
		marginLeft: "4px !important",
	},
	marginButton8: {
		marginBottom: "8px !important",
	},
	marginBottom12: {
		marginBottom: "12px !important",
	},
	margin8: {
		margin: "8px !important",
	},

	/** Typography */

	t16Bold: {
		fontSize: "16px",
		fontWeight: "500",
		color: theme.palette.grey[900],
		lineHeight: "1.43",
	},
	t16: {
		fontSize: "16px",
		color: theme.palette.grey[900],
		lineHeight: "1.43",
	},
	t14: {
		fontSize: "14px",
		lineHeight: "1.43",
		color: theme.palette.grey[900],
	},
	t14Bold: {
		fontSize: "14px",
		color: theme.palette.grey[900],
		fontWeight: "500",
		lineHeight: "1.43",
	},
	t12: {
		fontSize: "12px",
		lineHeight: "1.43",
		color: theme.palette.grey[900],
	},
	t12Bold: {
		fontSize: "12px",
		color: theme.palette.grey[900],
		fontWeight: "600",
		lineHeight: "1.43",
	},
	tNotificationCount: {
		color: theme.palette.common.white,
		background: theme.palette.primary.main,
		display: "inline-block",
		padding: "3px 7px",
		borderRadius: "50%",
		fontSize: "12px",
	},
	tCaption: {
		color: theme.palette.secondary.light,
	},
	tCaption2: {
		color: "rgba(42, 41, 42, 0.87)",
	},
	tCaption3: {
		color: theme.palette.grey[900],
	},
	tWhite: {
		color: theme.palette.common.white,
	},
	tLink: {
		color: theme.palette.primary.main,
		cursor: "pointer",
	},
	t12CapsBold: {
		fontSize: "12px",
		fontWeight: "600",
		letterSpacing: "1px",
		textTransform: "uppercase",
	},
	t22: {
		fontSize: "22px",
		color: theme.palette.grey[900],
		lineHeight: "1.43",
	},
	fontSize14: {
		fontSize: "14px",
	},
	tCaps: {
		textTransform: "capitalize",
	},
	tEC7474: {
		color: theme.palette.error.light,
	},
	tAlignCenter: {
		textAlign: "center",
	},
	tTag1: {
		color: theme.palette.common.white,
		backgroundColor: theme.palette.secondary.light,
		padding: "0px 4px",
	},
	/** Alignment */
	floatLeft: {
		float: "left",
	},
	floatRight: { float: "right" },

	/** Display */
	displayInlineBlock: {
		display: "inline-block",
	},

	heighLightBg: {
		backgroundColor: theme.palette.blueGrey.light,
	},

	subHeaderItem: {
		marginLeft: "16px",
	},
	textOverflowEllipsis: {
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},

	// Separator
	separatorTop: {
		borderTop: `solid 1px ${theme.palette.blueGrey.main}`,
	},
	separatorBottom: {
		borderBottom: `solid 1px ${theme.palette.blueGrey.main}`,
	},

	takeRestSpace: {
		flexGrow: "1",
	},

	userAvatar: {
		borderRadius: "50%",
	},
	anchorCssOverride: {
		textDecoration: "none",
		color: "inherit",
		"&:visited": {
			color: "inherit",
		},
	},

	// layout
	layoutContainer: {
		display: "flex",
		flexFlow: "column",
		height: "100%",
	},
	layoutHeader: {
		flex: "0 1 auto",
	},
	layoutBody: {
		flex: "1 1 auto",
	},
	layoutFooter: {
		flex: "0 1 auto",
	},

	// position
	positionRelative: {
		position: "relative",
	},

	// border
	borderBox1: {
		border: `1px solid ${theme.palette.blueGrey.main}`,
		borderRadius: "4px",
	},
	borderBottom: {
		borderBottom: `1px solid ${theme.palette.blueGrey.main}`,
	},

	borderLeftSeparator: {
		borderLeft: `2.5px solid ${theme.palette.blueGrey.main}`,
	},

	// cursor
	cursorPointer: {
		cursor: "pointer",
	},

	// color palete

	borderErrorColor: {
		borderColor: theme.palette.error.main,
	},

	colorLightPurple: {
		color: theme.palette.secondary.light,
	},

	cursorNotAllowed: {
		"> *": {
			cursor: "not-allowed !important",
		},
	},
	pointerEventNone: {
		pointerEvents: "none",
		opacity: 0.5,
	},

	surface: {
		backgroundColor: theme.palette.common.white,
	},
	flexJustifyContentSpaceBetween: {
		display: "flex",
		justifyContent: "space-between",
	},
});
